import { ESTABLECIMIENTOS_ENDPOINT, doGet } from "../utils/api";

export async function buscarEstablecimiento(CURT, token) {
  return await doGet(ESTABLECIMIENTOS_ENDPOINT + `/${CURT}`, null, null, token);
}
